module.exports = __webpack_public_path__ + "media/images/covid/icons/gargle-ba22d7a7e67357cd35aa38550482714e.png";